/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  fetchSeoTags,
  editSeoTags,
  updateSeoTags,
  trashSeoTags,
} from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import CKEditorField from "../../components/CKEditorField";

const SeoTagList = () => {
  const [seoTags, setSeoTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editRow, setEditRow] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [error, setError] = useState(null);
  const [ogImgFile, setOgImgFile] = useState(null);
  const [twitterImgFile, setTwitterImgFile] = useState(null);

  useEffect(() => {
    fetchSeoTag();
  }, []);

  const fetchSeoTag = async () => {
    try {
      const res = await fetchSeoTags();
      setSeoTags(res.data || []);
      //   setSeoTags(res.data && res.data.length > 0 ? [res.data[0]] : []);
    } catch (err) {
      setError("Failed to load SEO tags.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      const res = await editSeoTags(id);
      if (res && res.data) {
        const seoTags = res.data;
        setEditRow({
          id: seoTags.id,
          page: seoTags.page,
          seo_title: seoTags.seo_title,
          meta_title: seoTags.meta_title,
          meta_description: seoTags.meta_description,
          meta_keywords: seoTags.meta_keywords,
          custom_scripts: seoTags.custom_scripts,
          og_title: seoTags.og_title,
          og_description: seoTags.og_description,
          og_type: seoTags.og_type,
          og_url: seoTags.og_url,
          og_locale: seoTags.og_locale,
          og_site_name: seoTags.og_site_name,
          og_image: seoTags.og_image,
          og_image_width: seoTags.og_image_width,
          og_image_height: seoTags.og_image_height,
          og_image_type: seoTags.og_image_type,
          article_modified_time: seoTags.article_modified_time,
          canonical_link: seoTags.canonical_link,
          twitter_card: seoTags.twitter_card,
          twitter_site: seoTags.twitter_site,
          twitter_title: seoTags.twitter_title,
          twitter_description: seoTags.twitter_description,
        });
      } else {
        toast.error("Failed to load SEO tag details.");
      }
    } catch (err) {
      toast.error("Failed to fetch tag details.");
    }
  };

  const handleUpdate = async () => {
    setActionLoading(true);
    const formData = new FormData();
    formData.append("page", editRow.page);
    formData.append("seo_title", editRow.seo_title);
    formData.append("seo_title", editRow.seo_title);
    formData.append("meta_title", editRow.meta_title);
    formData.append("meta_description", editRow.meta_description);
    formData.append("meta_keywords", editRow.meta_keywords);
    formData.append("custom_scripts", editRow.custom_scripts);
    formData.append("og_title", editRow.og_title);
    formData.append("og_description", editRow.og_description);
    formData.append("og_type", editRow.og_type);
    formData.append("og_url", editRow.og_url);
    formData.append("og_locale", editRow.og_locale);
    formData.append("og_site_name", editRow.og_site_name);
    formData.append("og_image_width", editRow.og_image_width);
    formData.append("og_image_height", editRow.og_image_height);
    formData.append("og_image_type", editRow.og_image_type);
    formData.append("article_modified_time", editRow.article_modified_time);
    formData.append("canonical_link", editRow.canonical_link);
    formData.append("twitter_card", editRow.twitter_card);
    formData.append("twitter_site", editRow.twitter_site);
    formData.append("twitter_title", editRow.twitter_title);
    formData.append("twitter_description", editRow.twitter_description);
    if (editRow.og_image instanceof File) {
      formData.append("og_image", editRow.og_image);
    }
    if (editRow.twitter_image instanceof File) {
      formData.append("twitter_image", editRow.twitter_image);
    }
    try {
      const res = await updateSeoTags(editRow.id, formData);
      if (res.status === "true") {
        toast.success("SEO Tag updated successfully.");
        setSeoTags((prev) =>
          prev.map((tag) =>
            tag.id === editRow.id
              ? {
                ...tag,
                page: editRow.page,
                seo_title: editRow.seo_title,
                meta_title: editRow.meta_title,
                meta_description: editRow.meta_description,
                meta_keywords: editRow.meta_keywords,
                custom_scripts: editRow.custom_scripts,
                og_title: editRow.og_title,
                og_description: editRow.og_description,
                og_type: editRow.og_type,
                og_url: editRow.og_url,
                og_locale: editRow.og_locale,
                og_site_name: editRow.og_site_name,
                og_image: editRow.og_image,
                og_image_width: editRow.og_image_width,
                og_image_height: editRow.og_image_height,
                og_image_type: editRow.og_image_type,
                article_modified_time: editRow.article_modified_time,
                canonical_link: editRow.canonical_link,
                twitter_card: editRow.twitter_card,
                twitter_site: editRow.twitter_site,
                twitter_title: editRow.twitter_title,
                twitter_description: editRow.twitter_description,
                twitter_image: editRow.twitter_image,
              }
              : tag
          )
        );
        setEditRow(null);
      } else {
        toast.error("Failed to update SEO Tag.");
      }
    } catch (err) {
      toast.error("Update failed.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setActionLoading(true);
    try {
      const res = await trashSeoTags(id);
      if (res.status === "true") {
        toast.success("SEO Tag deleted.");
        setSeoTags((prev) => prev.filter((tag) => tag.id !== id));
        setDeleteId(null);
      } else {
        toast.error("Failed to delete tag.");
      }
    } catch (err) {
      toast.error("Delete failed.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleImgUpload = (e, key, setPrevieState) => {
    const file = e.target.files[0];
    if (file) {
      setPrevieState(file);
      setEditRow((prev) => ({
        ...prev,
        [key]: file,
      }));
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "page", headerName: "Page", width: 200 },
    { field: "seo_title", headerName: "SEO Title", width: 200 },
    { field: "seo_title", headerName: "SEO Title", width: 200 },
    { field: "meta_title", headerName: "Meta Title", width: 200 },

    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleEdit(params.row.id)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => setDeleteId(params.row.id)}
            style={{ marginLeft: 8 }}
          >
            Trash
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box p={3}>
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Seo Tag Management
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <DataGrid rows={seoTags} columns={columns} autoHeight />
      )}

      {/* Edit Dialog */}
      {editRow && (
        <Dialog open onClose={() => setEditRow(null)} maxWidth="sm">
          <DialogTitle>Edit SEO Tag</DialogTitle>
          <DialogContent>
            <TextField
              label="Page"
              fullWidth
              margin="normal"
              value={editRow.page}
              onChange={(e) => setEditRow({ ...editRow, page: e.target.value })}
            />
            <TextField
              label="SEO Title"
              fullWidth
              margin="normal"
              value={editRow.seo_title}
              onChange={(e) =>
                setEditRow({ ...editRow, seo_title: e.target.value })
              }
            />
            <TextField
              label="Meta Title"
              fullWidth
              margin="normal"
              value={editRow.meta_title}
              onChange={(e) =>
                setEditRow({ ...editRow, meta_title: e.target.value })
              }
            />
            <Typography variant="body1" mt={2}>
              Meta Description
            </Typography>
            {/* <ReactQuill
              theme="snow"
              value={editRow.meta_description}
              onChange={(value) =>
                setEditRow({ ...editRow, meta_description: value })
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editRow.meta_description}
            onChange={(data) => setEditRow((prev) => ({ ...prev, meta_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />

            <TextField
              label="Meta Keywords"
              fullWidth
              margin="normal"
              value={editRow.meta_keywords}
              onChange={(e) =>
                setEditRow({ ...editRow, meta_keywords: e.target.value })
              }
            />
	      {/* <Typography variant="body1" mt={2}>
              Custom Scripts
            </Typography>
            <ReactQuill
              theme="snow"
              value={editRow.custom_scripts}
              onChange={(value) =>
                setEditRow((prev) => ({ ...prev, custom_scripts: value }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}  
	      <TextField
              label="Custom Scripts"
              name="custom_scripts"
              value={editRow.custom_scripts}
              onChange={(e) =>
                setEditRow((prev) => ({ ...prev, custom_scripts: e.target.value }))
              }
              fullWidth
              multiline
              minRows={10}
              maxRows={30}
              variant="outlined"
              style={{ marginBottom: "60px" }}
              placeholder={`Paste raw script here. Example:
                      <script type="application/ld+json">
                      { "jsonld": "data" }
                      </script>`}
            />
            <TextField
              label="OG Title"
              name="og_title"
              value={editRow.og_title}
              onChange={(e) =>
                setEditRow({ ...editRow, og_title: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <Typography variant="body1">Og Description</Typography>
            {/* <ReactQuill
              theme="snow"
              value={editRow.og_description}
              onChange={(value) =>
                setEditRow((prev) => ({ ...prev, og_description: value }))
              }
              style={{ height: "200px", marginBottom: "50px" }}
            /> */}
            <CKEditorField
            value={editRow.og_description}
            onChange={(data) => setEditRow((prev) => ({ ...prev, og_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />
            <TextField
              label="OG Type"
              name="og_type"
              value={editRow.og_type}
              onChange={(e) =>
                setEditRow({ ...editRow, og_type: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="OG URL"
              name="og_url"
              value={editRow.og_url}
              onChange={(e) =>
                setEditRow({ ...editRow, og_url: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="Og Locale"
              name="og_locale"
              value={editRow.og_locale}
              onChange={(e) =>
                setEditRow({ ...editRow, og_locale: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="OG Site Name"
              name="og_site_name"
              value={editRow.og_site_name}
              onChange={(e) =>
                setEditRow({ ...editRow, og_site_name: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="Og Image Width"
              name="og_image_width"
              value={editRow.og_image_width}
              onChange={(e) =>
                setEditRow({ ...editRow, og_image_width: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="Og Image Height"
              name="og_image_height"
              value={editRow.og_image_height}
              onChange={(e) =>
                setEditRow({ ...editRow, og_image_height: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="Og Image Type"
              name="og_image_type"
              value={editRow.og_image_type}
              onChange={(e) =>
                setEditRow({ ...editRow, og_image_type: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <Typography variant="body1" mt={2}>
              Article Modified Time
            </Typography>
            <TextField
              // label="Article Modified Time"
              name="article_modified_time"
              type="datetime-local"
              value={editRow.article_modified_time}
              onChange={(e) =>
                setEditRow({
                  ...editRow,
                  article_modified_time: e.target.value,
                })
              }
              fullWidth
            // margin="normal"
            />
            <TextField
              label="Canonical URL"
              fullWidth
              margin="normal"
              value={editRow.canonical_link}
              onChange={(e) =>
                setEditRow({ ...editRow, canonical_link: e.target.value })
              }
            />

            <TextField
              label="Twitter Card"
              name="twitter_card"
              value={editRow.twitter_card}
              onChange={(e) =>
                setEditRow({ ...editRow, twitter_card: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="Twitter Site"
              name="twitter_site"
              value={editRow.twitter_site}
              onChange={(e) =>
                setEditRow({ ...editRow, twitter_site: e.target.value })
              }
              fullWidth
              margin="normal"
            />
            <TextField
              label="Twitter Title"
              name="twitter_title"
              value={editRow.twitter_title}
              onChange={(e) =>
                setEditRow({ ...editRow, twitter_title: e.target.value })
              }
              fullWidth
              margin="normal"
            />

            <Typography variant="body1" mt={2}>
              Twitter Description
            </Typography>
            {/* <ReactQuill
              theme="snow"
              value={editRow.twitter_description}
              onChange={(value) =>
                setEditRow((prev) => ({ ...prev, twitter_description: value }))
              }
              style={{ height: "200px", marginBottom: "80px" }}
            /> */}
            <CKEditorField
            value={editRow.twitter_description}
            onChange={(data) => setEditRow((prev) => ({ ...prev, twitter_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=seo`}
          />
            <Box
              mt={2}
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
            >
              <Button
                variant="contained"
                component="label"
                style={{ marginTop: "20px" }}
              >
                Upload Og Image
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => handleImgUpload(e, "og_image", setOgImgFile)}
                />
              </Button>

              <Box mt={2}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {ogImgFile ? "Preview of Selected Image:" : "Existing Image:"}
                </Typography>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={
                      ogImgFile
                        ? URL.createObjectURL(ogImgFile)
                        : `${baseImage_path}/${editRow?.og_image}`
                    }
                    alt="Og Image"
                    style={{
                      width: 100,
                      height: "auto",
                      borderRadius: 4,
                    }}
                  />
                </div>
              </Box>
            </Box>

            <Box
              mt={2}
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
            >
              <Button
                variant="contained"
                component="label"
                style={{ marginTop: "20px" }}
              >
                Upload Twitter Image
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) =>
                    handleImgUpload(e, "twitter_image", setTwitterImgFile)
                  }
                />
              </Button>
              <Box mt={2}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {twitterImgFile
                    ? "Preview of Selected Image:"
                    : "Existing Image:"}
                </Typography>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={
                      twitterImgFile
                        ? URL.createObjectURL(twitterImgFile)
                        : `${baseImage_path}/${editRow?.twitter_image}`
                    }
                    alt="Twitter Image"
                    style={{
                      width: 100,
                      height: "auto",
                      borderRadius: 4,
                    }}
                  />
                </div>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setEditRow(null)}
              variant="outlined"
              style={{ backgroundColor: "#ccc" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdate}
              variant="contained"
              color="primary"
              disabled={actionLoading}
            >
              {actionLoading ? <CircularProgress size={24} /> : "Save"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Delete Confirmation Dialog */}
      {deleteId && (
        <Dialog open onClose={() => setDeleteId(null)}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this SEO Tag?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteId(null)} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={() => handleDelete(deleteId)}
              variant="contained"
              color="error"
              disabled={actionLoading}
            >
              {actionLoading ? <CircularProgress size={24} /> : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default SeoTagList;
